import { useMutation } from "@tanstack/react-query";

import createAffiliatePortalInstance from "../../api/AffiliatePortalInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { getAffiliatePortalToken } from "../../utils/tokenUtils";

const portalSignOut = async (): Promise<void> => {
  const token = getAffiliatePortalToken();
  const instance = createAffiliatePortalInstance();

  await instance.post(API_ROUTES.SIGN_OUT, {
    request_token: token?.AccessToken,
  });
};

export const usePortalSignOut = () =>
  useMutation<void, Error>({
    mutationKey: ["affiliate-portal", "signOut"],
    mutationFn: portalSignOut,
  });
